import React, { useContext, useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
import { UserContext } from './UserContext'; // Importa il contesto
import TestataAdmin from "./partials/TestataAdmin";
import Footer from "./partials/Footer";
import Cuoricini from "./partials/Cuoricini";
import $ from 'jquery';
import 'datatables.net';
function ElencoAnnunci() {
  const { userData } = useContext(UserContext); // Ottieni userData dal contesto
  const [annunci, setAnnunci] = useState([]); // Stato per gli Annunci
  const [errorDoc, setDocError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [likes, setLikes] = useState(0);
//   const navigate = useNavigate();

  useEffect(() => {   
    const fetchAnnunci = async () => {
      const token = localStorage.getItem('token');
        try {
            const response = await fetch(`/api/annunciAdmin`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
            });

            if (response.ok) {
            const utenti = await response.json();
            setAnnunci(utenti); // Aggiorna lo stato con i Clienti ricevuti
            } else {
            throw new Error('Errore nel recupero dei Utenti');
            }
        } catch (err) {
            setDocError(err.message);
        }
    };

    fetchAnnunci(); 
  }, []);// Chiama la funzione per recuperare i Clienti    

  // Ref per l'elemento della tabella
  const tableRef = useRef(null);

  useEffect(() => {
    // Funzione per inizializzare o aggiornare la DataTable
    let table;
    const initializeOrUpdateTable = () => {
        if (!$.fn.DataTable.isDataTable(tableRef.current)) {
            // Inizializza la DataTable solo se non è già stata inizializzata
            table = $(tableRef.current).DataTable({ // Assegna il valore a table
                responsive: true,
                ordering: true,
                searching: true,
                paging: true,
                info: true,
                dom: "frtip",
                buttons: ["copy", "csv", "excel", "pdf", "print"],
                language: {
                url: "/js/it-IT.json",
                },
                pageLength: 10,
            });
        }
        // Ottieni l'istanza della DataTable
        const dataTable = $(tableRef.current).DataTable();

        // Usa l'API di DataTables per gestire l'evento di click sulle righe della tabella
        dataTable.on('click', 'tr', function (event) {
            event.stopPropagation(); // Impedisci la propagazione dell'evento
            // Ottieni l'elemento <td> che contiene l'immagine
            const imageCell = $(this).find('td:first-child'); 

            // Ottieni l'elemento <img> all'interno della cella
            const imageElement = imageCell.find('img');

            // Verifica se l'immagine esiste e ha un attributo src
            if (imageElement.length > 0 && imageElement.attr('src')) {
                const imageUrl = imageElement.attr('src');
                handleImageClick(imageUrl);
            }
        });
    };

        // Verifica se tableRef.current è definito prima di inizializzare o aggiornare
        if (tableRef.current) {
            setTimeout(initializeOrUpdateTable, 500); // Timeout per garantire che il DOM sia pronto
        }

    // Distruggi la DataTable quando il componente viene smontato
    return () => {
        if (table && table.destroy) { // Controlla se table è definito e ha il metodo destroy
            table.destroy();
        }
    };
    }, [annunci]);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

    return (
      <>
      <section className="main_content dashboard_part">
        <div className='className="container-fluid g-0'>            
            <TestataAdmin userData={userData} />
        </div>
            <div className="main_content_iner ">
                <div className="container-fluid plr_30 body_white_bg pt_30">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="white_box_tittle list_header">
                                <h4>Annunci attualmente pubblicati</h4>
                            </div>
                            {errorDoc ? (
                                <h5>Errore: {errorDoc}</h5>
                            ) : (
                                <div className="table-responsive mb_50 text text-center">
                                    <table className="table table-striped" id="datatable" style={{width: '100%'}} ref={tableRef}>
                                        <thead>
                                            <tr>
                                                <th style={{width: '10%', fontWeight: '400', fontStyle: 'italic'}}>Miniatura</th>
                                                <th style={{width: '20%', fontWeight: '400', fontStyle: 'italic'}}>Agenzia</th>
                                                <th style={{width: '35%', fontWeight: '400', fontStyle: 'italic'}}>Nominativo del defunto</th>
                                                <th style={{width: '15%', fontWeight: '400', fontStyle: 'italic'}}>Regione</th>
                                                <th style={{width: '20%', fontWeight: '400', fontStyle: 'italic'}}>Comune</th>
                                                <th style={{width: '5%', fontWeight: '400', fontStyle: 'italic'}}>Azioni</th>
                                            </tr>
                                        </thead>                                              
                                        <tbody>
                                            {annunci.map(annuncio => (
                                                <tr key={annuncio._id}>
                                                    <td>
                                                        {annuncio.img ? (
                                                            <img 
                                                                src={`/necrologi/${annuncio.id_utente}/${annuncio.img}`} 
                                                                className='responsive' 
                                                                alt="Miniatura dell'annuncio" 
                                                                onClick={() => handleImageClick(`/necrologi/${annuncio.id_utente}/${annuncio.img}`)} // Aggiungi onClick
                                                                />
                                                        ) : (
                                                            <img src="/necrologi/pixel.png" alt="Immagine mancante" />
                                                        )}
                                                    </td>
                                                    <td>
                                                        <p>
                                                            <a href={`/amministratore/utente/${annuncio.id_utente}`} title="Vedi dettaglio anagrafica dell'Agenzia" style={{color: annuncio.disattivo === true ? '#cf6969' : '#b19DC9', textDecoration: annuncio.disattivo === true ? 'line-through' : 'none', fontWeight: '500'}}>
                                                                {annuncio.ragSociale}
                                                            </a>
                                                        </p>
                                                    </td>                                                    
                                                    <td><p style={{fontWeight: '500'}}>{annuncio.cuori > 0 && <Cuoricini likes={annuncio.cuori} />}{" "}{annuncio.nome} {annuncio.cognome}</p></td>
                                                    <td><p style={{fontWeight: '400'}}>{annuncio.regione}</p></td>
                                                    <td><p style={{fontWeight: '400'}}>{annuncio.comune} ({annuncio.prov})</p></td>
                                                    <td><a href={`/amministratore/annuncio/${annuncio._id}`} className="btn btn-sm btn-primary" style={{float: "right", fontSize: "0.66rem"}}>Info</a></td>
                                                </tr>
                                            ))}                                            
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th style={{width: '10%', fontWeight: '400', fontStyle: 'italic'}}>Miniatura</th>
                                                <th style={{width: '20%', fontWeight: '400', fontStyle: 'italic'}}>Agenzia</th>
                                                <th style={{width: '35%', fontWeight: '400', fontStyle: 'italic'}}>Nominativo del defunto</th>
                                                <th style={{width: '15%', fontWeight: '400', fontStyle: 'italic'}}>Regione</th>
                                                <th style={{width: '20%', fontWeight: '400', fontStyle: 'italic'}}>Comune</th>
                                                <th style={{width: '5%', fontWeight: '400', fontStyle: 'italic'}}>Azioni</th>
                                            </tr>
                                        </tfoot>   
                                    </table>
                                    {/* Modale */}
                                    {modalOpen && (
                                        <div className="modal">
                                        <div className="modal-content">
                                            <span className="chiudix" onClick={closeModal}>&times;</span>
                                            <img src={selectedImage} alt="Immagine ingrandita" />
                                        </div>
                                        </div>
                                    )}</div>
                                )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </section>
      </>
    );
  }

export default ElencoAnnunci;
